import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

type Props = {
	icon: IconProp;
};

const FASvgIcon: React.FC<Props> = (props: Props) => {
	const { icon } = props;

	return <FontAwesomeIcon icon={icon} className="eds-icon" />;
};

export default FASvgIcon;
